import { SESSION_TIME_OUT_DELAY, SKIPPED, createValueHistory, isEmptyObject } from '@datadog/browser-core';
import { RumEventType } from '../../rawRumEvent.types';
export var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
export var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */

export function startFeatureFlagContexts(lifeCycle, hooks, configuration) {
  var featureFlagContexts = createValueHistory({
    expireDelay: FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY
  });
  lifeCycle.subscribe(1
  /* LifeCycleEventType.BEFORE_VIEW_CREATED */
  , function (_ref) {
    var startClocks = _ref.startClocks;
    featureFlagContexts.add({}, startClocks.relative);
  });
  lifeCycle.subscribe(6
  /* LifeCycleEventType.AFTER_VIEW_ENDED */
  , function (_ref2) {
    var endClocks = _ref2.endClocks;
    featureFlagContexts.closeActive(endClocks.relative);
  });
  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref3) {
    var startTime = _ref3.startTime,
        eventType = _ref3.eventType;
    var trackFeatureFlagsForEvents = configuration.trackFeatureFlagsForEvents.concat([RumEventType.VIEW, RumEventType.ERROR]);

    if (!trackFeatureFlagsForEvents.includes(eventType)) {
      return SKIPPED;
    }

    var featureFlagContext = featureFlagContexts.find(startTime);

    if (!featureFlagContext || isEmptyObject(featureFlagContext)) {
      return SKIPPED;
    }

    return {
      type: eventType,
      feature_flags: featureFlagContext
    };
  });
  return {
    addFeatureFlagEvaluation: function addFeatureFlagEvaluation(key, value) {
      var currentContext = featureFlagContexts.find();

      if (currentContext) {
        currentContext[key] = value;
      }
    }
  };
}